import { EnvironmentProfile } from './interfaces';

export const profiles: Record<string, EnvironmentProfile> = {
  local: {
    name: 'local',
    api: 'http://localhost:4200',
    url: 'http://localhost:4200',
    msalConfig: {
      auth: {
        clientId: '35c3e6ca-ac69-4d6d-be34-d7741289942a',
        authority: 'https://login.microsoftonline.com/7849ae70-f969-4dae-a3eb-fcefa4b60df1',
      },
    },
  },
  entwicklung: {
    name: 'entwicklung',
    api: 'https://art-cp-ent.aks-01.compeople.dev',
    url: 'https://art-cp-ent.aks-01.compeople.dev',
    msalConfig: {
      auth: {
        clientId: '35c3e6ca-ac69-4d6d-be34-d7741289942a',
        authority: 'https://login.microsoftonline.com/7849ae70-f969-4dae-a3eb-fcefa4b60df1',
      },
    },
  },
  integration: {
    name: 'integration',
    api: '',
    url: '',
    msalConfig: {
      auth: {
        clientId: '',
        authority: '',
      },
    },
  },
  abnahme: {
    name: 'abnahme',
    api: '',
    url: '',
    msalConfig: {
      auth: {
        clientId: '',
        authority: '',
      },
    },
  },
  produktion: {
    name: 'produktion',
    api: '',
    url: '',
    msalConfig: {
      auth: {
        clientId: '',
        authority: '',
      },
    },
  },
};
